<template>
    <div class="management-container">
      <div class="game-servers-options-container">
        <h1 class="gsoc-heading content-header">Manage Zones</h1>
      </div>


      <div class="flex-container">
          <select
            name=""
            id=""
            class="dropdown"
            v-model="selectedGameServer"
            @change="updateSelectedGameServer"
          >
            <option disabled value="null">Choose Game Server</option>
            <option v-for="server in allLinkedServers" :key="server.id" :value="server">
              {{ server.server_identifier }}
            </option>
          </select>
          <button @click="showModalPopup('addZone')" class="btn action-btn" :disabled="!selectedGameServer">
            Create New Zone
          </button>
    
          <button @click="loadZones" class="btn action-btn" :disabled="!selectedGameServer">
            Load Zones
          </button>
      </div>
  



      <div id="gameMap">

       
        <div class="coordinates-container" v-if="mouseCoordinates.x && mouseCoordinates.y">
          <p class="coordinates-text">X:{{ mouseCoordinates.x }}, Y:{{ mouseCoordinates.y }}</p>
      </div>

      <div class="mapToolbar">
        <button class="mapToolbarButton" @click="openConfirmModal" v-if="newZone">
            <svg
              width="24"
              height="24"
              viewBox="0 0 17 16"
              fill="none"
              xmlns="http://www.w3.org/2000/svg"
            >
              <path
                d="M3.83325 8.66675L6.49992 11.3334L13.1666 4.66675"
                stroke="black"
                stroke-width="1.5"
                stroke-linecap="round"
                stroke-linejoin="round"
              />
            </svg>
        </button>
        <button class="mapToolbarButton" @click="confirmZoneEditChanges" v-if="editingZone">
            <svg
              width="24"
              height="24"
              viewBox="0 0 17 16"
              fill="none"
              xmlns="http://www.w3.org/2000/svg"
            >
              <path
                d="M3.83325 8.66675L6.49992 11.3334L13.1666 4.66675"
                stroke="black"
                stroke-width="1.5"
                stroke-linecap="round"
                stroke-linejoin="round"
              />
            </svg>
        </button>
        
    <button class="mapToolbarButton" v-if="editingZone && selectedZoneUpdated.zone_type == 'shape'" @click="removeLastPolygonPointEdit">
        <svg width="16" height="16" viewBox="0 0 10 11" fill="black" xmlns="http://www.w3.org/2000/svg">
    <path d="M1 9.5L9 1.5M1 1.5L9 9.5" stroke="black"  stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>
    </svg>
</button>
<button class="mapToolbarButton" v-if="newZone && newZone.zone_type == 'shape'" @click="removeLastPolygonPoint">
        <svg width="16" height="16" viewBox="0 0 10 11" fill="black" xmlns="http://www.w3.org/2000/svg">
    <path d="M1 9.5L9 1.5M1 1.5L9 9.5" stroke="black"  stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>
    </svg>
</button>

    <button class="mapToolbarButton" v-if="loadedZones && !editingZone && !newZone" @click="showModalPopup('editZones')">
        <svg fill="#000000" viewBox="0 0 32 32" version="1.1" xmlns="http://www.w3.org/2000/svg"><g id="SVGRepo_bgCarrier" stroke-width="0"></g><g id="SVGRepo_tracerCarrier" stroke-linecap="round" stroke-linejoin="round"></g><g id="SVGRepo_iconCarrier"> <path d="M12.15 28.012v-0.85c0.019-0.069 0.050-0.131 0.063-0.2 0.275-1.788 1.762-3.2 3.506-3.319 1.95-0.137 3.6 0.975 4.137 2.787 0.069 0.238 0.119 0.488 0.181 0.731v0.85c-0.019 0.056-0.050 0.106-0.056 0.169-0.269 1.65-1.456 2.906-3.081 3.262-0.125 0.025-0.25 0.063-0.375 0.094h-0.85c-0.056-0.019-0.113-0.050-0.169-0.056-1.625-0.262-2.862-1.419-3.237-3.025-0.037-0.156-0.081-0.3-0.119-0.444zM20.038 3.988l-0 0.85c-0.019 0.069-0.050 0.131-0.056 0.2-0.281 1.8-1.775 3.206-3.538 3.319-1.944 0.125-3.588-1-4.119-2.819-0.069-0.231-0.119-0.469-0.175-0.7v-0.85c0.019-0.056 0.050-0.106 0.063-0.162 0.3-1.625 1.244-2.688 2.819-3.194 0.206-0.069 0.425-0.106 0.637-0.162h0.85c0.056 0.019 0.113 0.050 0.169 0.056 1.631 0.269 2.863 1.419 3.238 3.025 0.038 0.15 0.075 0.294 0.113 0.437zM20.037 15.575v0.85c-0.019 0.069-0.050 0.131-0.063 0.2-0.281 1.794-1.831 3.238-3.581 3.313-1.969 0.087-3.637-1.1-4.106-2.931-0.050-0.194-0.094-0.387-0.137-0.581v-0.85c0.019-0.069 0.050-0.131 0.063-0.2 0.275-1.794 1.831-3.238 3.581-3.319 1.969-0.094 3.637 1.1 4.106 2.931 0.050 0.2 0.094 0.394 0.137 0.588z"></path> </g></svg>

</button>
      </div>

         
      </div>
  
    
    </div>

    <Modal
      :show="showModal"
    >
      <template v-slot:header-content v-if="modalContent === 'addZone'">
        <div class="modal-header-content-container">
          <p class="modal-sub-heading">Zones</p>
          <p class="modal-main-heading">Create A New Zone</p>
        </div>
        
      </template>

      <template v-slot:header-content v-if="modalContent === 'editZones'">
        <div class="modal-header-content-container">
          <p class="modal-sub-heading">Zones</p>
          <p class="modal-main-heading">Edit Zones</p>
        </div>

          <div class="modal-heading-discord-id-validator">
            <input
              type="text"
              placeholder="Search zones"
              class="modal-option-input search-input"
              v-model="searchFilter"
            />
          </div>
      </template>

      <template v-slot:header-content v-if="modalContent === 'zoneEditor'">
        <div class="modal-header-content-container">
          <p class="modal-sub-heading">{{ selectedZoneUpdated.zone_name }}</p>
          <p class="modal-main-heading">Edit Zones</p>
        </div>
      </template>

      <template v-slot:body-content v-if="modalContent === 'addZone'">
        <div class="modal-body-content-container">
          <div class="modal-body-container">
            <div class="modal-row">
            <div class="modal-input">
              <label for="zone-name" class="label required-input"
                >Zone Name</label
              >
              <input
                type="text"
                id="zone-name"
                class="input"
                v-model="newZone.zone_name"
                :disabled = "finalConfirm"
                :readonly = "finalConfirm"
              />
            </div>
            <div class="modal-input">
              <label for="zone-type" class="label required-input"
                >Zone Type</label
              >
              <select
                name=""
                id=""
                class="dropdown"
                v-model="newZone.zone_type"
                :disabled = "finalConfirm"
                :readonly = "finalConfirm"
              >
                <option value="radius">Radius</option>
                <option value="shape">Shape</option>
              </select>
            </div>
          </div>

          <div class="modal-row" v-if="newZone.zone_type === 'radius'">
            <div class="modal-input">
              <label for="zone-radius" class="label required-input"
                >Zone Radius</label
              >
              <input
                type="text"
                id="zone-radius"
                class="input"
                v-model="newZone.radius"
                :disabled = "finalConfirm"
                :readonly = "finalConfirm"
              />
            </div>
            <div class="modal-input" v-if="finalConfirm">
              <label for="zone-coordinates" class="label required-input"
                >Coordinates</label
              >
              <input
                type="text"
                id="zone-radius"
                class="input"
                readonly
                :value="`X: ${newZone.x_coordinate}, Y: ${newZone.y_coordinate}`"
              />
            </div>
           
          </div>

          <div class="modal-row" v-if="finalConfirm">
            <div class="modal-input">
                <label for="zone-channel" class="label required-input"
                    >Channel</label
                >
                <select
                    name=""
                    id=""
                    class="dropdown"
                    v-model="newZone.channel_id"
                >
                    <option disabled value="null">Choose Channel</option>
                    <option v-for="channel in channels" :key="channel.id" :value="channel.id">
                    {{ channel.name }}
                    </option>
                </select>
                
            </div>
            <div class="modal-input">
                <label for="zone-duration" class="label"
                    >Duration (Days)</label
                >
                <input
                    type="number"
                    id="zone-duration"
                    class="input"
                    v-model="newZone.duration"
                />
            </div>
           

          </div>

          <div class="modal-row"v-if="finalConfirm">
            <div class="modal-input">
                <label for="zone-role" class="label"
                    >Role To Ping</label
                >
                <select
                    name=""
                    id=""
                    class="dropdown"
                    v-model="newZone.role_id"
                >
                    <option value="null">Choose Role</option>
                    <option v-for="role in roles" :key="role.id" :value="role.id">
                    {{ role.name }}
                    </option>
                </select>
                
            </div>
            
            <div class="modal-input">
                <label for="zone-ping-role" class="label"
                    >Ping Role On Enter</label
                >
                <select
                    name=""
                    id=""
                    class="dropdown"
                    v-model="newZone.role_ping"

                >
                    <option value="false">False</option>
                    <option value="true">True</option>
                </select>
            </div>
            
          </div>

          <div class="modal-row" v-if="finalConfirm">
            <div class="modal-input">
                <label for="zone-ban-on-enter" class="label"
                    >Ban On Enter</label
                >
                <select
                    name=""
                    id=""
                    class="dropdown"
                    v-model="newZone.ban_on_enter"
                >
                    <option value="false">False</option>
                    <option value="true">True</option>
                </select>
            </div>

            <div class="modal-input">
                <label for="zone-ban-on-enter-duration" class="label"
                    >Ban On Enter Duration (mins)</label
                >
                <input
                    type="number"
                    id="zone-ban-on-enter-duration"
                    class="input"
                    v-model="newZone.ban_on_enter_duration"
                />

            </div>
          </div>

          <div class="modal-row" v-if="finalConfirm">
            <div class="modal-input">
                <label for="zone-ban-on-kill" class="label"
                    >Ban On kill</label
                >
                <select
                    name=""
                    id=""
                    class="dropdown"
                    v-model="newZone.ban_on_kill"
                >
                    <option value="false">False</option>
                    <option value="true">True</option>
                </select>
            </div>

            <div class="modal-input">
                <label for="zone-ban-on-kill-duration" class="label"
                    >Ban On kill Duration (mins)</label
                >
                <input
                    type="number"
                    id="zone-ban-on-kill-duration"
                    class="input"
                    v-model="newZone.ban_on_kill_duration"
                />

            </div>
          </div>

          <div class="modal-row" v-if="finalConfirm">
            <div class="modal-input">
                <label for="zone-ban-on-build" class="label"
                    >Ban On build</label
                >
                <select
                    name=""
                    id=""
                    class="dropdown"
                    v-model="newZone.ban_on_build"
                >
                    <option value="false">False</option>
                    <option value="true">True</option>
                </select>
            </div>

            <div class="modal-input">
                <label for="zone-ban-on-build-duration" class="label"
                    >Ban On build Duration (mins)</label
                >
                <input
                    type="number"
                    id="zone-ban-on-build-duration"
                    class="input"
                    v-model="newZone.ban_on_build_duration"
                />

            </div>
          </div>


          <div class="modal-row" v-if="finalConfirm">
            <div class="modal-input">
                <label for="zone-kill-credit-multiplier" class="label"
                    >Kill Credits Multiplier</label
                >
                <input
                    type="number"
                    id="zone-kill-credit-multiplier"
                    class="input"
                    v-model="newZone.kill_credit_multiplier"
                />
            </div>
          </div>

          <div class="modal-row full-row" v-if="finalConfirm">
            <div class="modal-input">
                <label for="zone-ignore-list" class="label"
                    >Gamertags to ignore (Seperate with ,)</label
                >
                <textarea
                    type="textarea"
                    id="zone-ignore-list"
                    class="input"
                    v-model="ignoreListAdd"
                    placeholder="Gamertags to ignore (Seperate with ,)"
                >
                </textarea>
            </div>
          </div>

          <div class="modal-row full-row" v-if="finalConfirm">
            <div class="modal-input">
                <label for="zone-description" class="label"
                    >Zone Description</label
                >
                <textarea
                    type="textarea"
                    id="zone-description"
                    class="input"
                    v-model="newZone.zone_description"
                   
                >
                </textarea>
            </div>
          </div>

          
          
          </div>
        </div>

        

      </template>

      <template v-slot:body-content v-if="modalContent === 'editZones'" >
       

       <div class="modal-body-content-container">
         <div class="modal-body-container">
     <div
     v-for="zone in filteredZones"
     :key="zone.zone_id"
     class="modal-checkbox-select"
     :class="{ 'active-checked': !this.hiddenZones.some(hiddenZone => hiddenZone.zone_id === zone.zone_id)}"
     @click="toggleZone"
   >
           <input
       type="checkbox"
       :id="zone.zone_id"
       class="checkbox"
       :checked="!this.hiddenZones.some(hiddenZone => hiddenZone.zone_id === zone.zone_id)"
     
       />
     <label :for="zone.zone_name" :id="zone.zone_id" class="checkbox-label"></label>

     <p class="checkbox-name">{{ zone.zone_name }}</p>

     <svg width="20" height="20" viewBox="0 0 14 14" fill="none" xmlns="http://www.w3.org/2000/svg" @click="showModalPopup('zoneEditor', zone.zone_id)" class="edit-icon">
<path d="M9.51018 2.51017C9.63932 2.37645 9.7938 2.2698 9.96461 2.19643C10.1354 2.12305 10.3191 2.08443 10.505 2.08282C10.6909 2.0812 10.8753 2.11662 11.0473 2.18702C11.2194 2.25741 11.3757 2.36136 11.5071 2.49281C11.6386 2.62426 11.7425 2.78058 11.8129 2.95263C11.8833 3.12469 11.9187 3.30904 11.9171 3.49493C11.9155 3.68082 11.8769 3.86453 11.8035 4.03533C11.7301 4.20614 11.6235 4.36062 11.4898 4.48977L10.9347 5.04487L8.95508 3.06527L9.51018 2.51017ZM7.96528 4.05507L2.09998 9.92037V11.9H4.07958L9.94558 6.03467L7.96528 4.05507Z" fill="#BBCED8" fill-opacity="0.64"/>
</svg >

   </div>
 </div>
         </div>

     </template>

     <template v-slot:body-content v-if="modalContent === 'zoneEditor'">
        <div class="modal-body-content-container">
          <div class="modal-body-container">
            <div class="modal-row">
            <div class="modal-input">
              <label for="zone-name" class="label"
                >Zone Name</label
              >
              <input
                type="text"
                id="zone-name"
                class="input"
                v-model="selectedZoneUpdated.zone_name"
                
              />
            </div>
            <div class="modal-input">
              <label for="zone-type" class="label "
                >Zone Type</label
              >
              <select
                name=""
                id=""
                class="dropdown"
                v-model="selectedZoneUpdated.zone_type"
                :disabled ="true"
              >
                <option value="radius">Radius</option>
                <option value="shape">Shape</option>
              </select>
            </div>
          </div>

          <div class="modal-row" v-if="selectedZoneUpdated.zone_type === 'radius'">
            <div class="modal-input">
              <label for="zone-radius" class="label"
                >Zone Radius</label
              >
              <input
                type="text"
                id="zone-radius"
                class="input"
                v-model="selectedZoneUpdated.radius"
                
              />
            </div>
            <div class="modal-input" @click="updateRadiusCoordinates" >
              <label for="zone-coordinates" class="label"
                >Coordinates (Click to update)</label
              >
              <input
                type="text"
                id="zone-coords"
                class="input"
                readonly
                :value="`X: ${selectedZoneUpdated.point[0]}, Y: ${selectedZoneUpdated.point[1]}`"
              />
            </div>
           
          </div>
          <div class="modal-row full-row " v-if="selectedZoneUpdated.zone_type === 'shape'">
    
            <div class="modal-input" @click="updateShapeZone" >
              <label for="zone-coordinates" class="label"
                >Coordinates (Click to update)</label
              >
              <input
                type="text"
                id="zone-coords"
                class="input"
                readonly
                value="Shape"
                
              />
            </div>
           
          </div>

          <div class="modal-row" >
            <div class="modal-input">
                <label for="zone-channel" class="label required-input"
                    >Channel</label
                >
                <select
                    name=""
                    id=""
                    class="dropdown"
                    v-model="selectedZoneUpdated.channel_id"
                >
                    <option disabled value="null">Choose Channel</option>
                    <option v-for="channel in channels" :key="channel.id" :value="Number(channel.id)">
                    {{ channel.name }}
                    </option>
                </select>
                
            </div>
            <div class="modal-input">
                <label for="zone-duration" class="label"
                    >Duration (Days)</label
                >
                <input
                    type="number"
                    id="zone-duration"
                    class="input"
                    v-model="selectedZoneUpdated.duration"
                />
            </div>
           

          </div>

          <div class="modal-row">
            <div class="modal-input">
                <label for="zone-role" class="label"
                    >Role To Ping</label
                >
                <select
                    name=""
                    id=""
                    class="dropdown"
                    v-model="selectedZoneUpdated.role_id"
                >
                    <option value="null">Choose Role</option>
                    <option v-for="role in roles" :key="role.id" :value="Number(role.id)">
                    {{ role.name }}
                    </option>
                </select>
                
            </div>
            
            <div class="modal-input">
                <label for="zone-ping-role" class="label"
                    >Ping Role On Enter</label
                >
                <select
                    name=""
                    id=""
                    class="dropdown"
                    v-model="selectedZoneUpdated.role_ping"

                >
                    <option value="false">False</option>
                    <option value="true">True</option>
                </select>
            </div>
            
          </div>

          <div class="modal-row" >
            <div class="modal-input">
                <label for="zone-ban-on-enter" class="label"
                    >Ban On Enter</label
                >
                <select
                    name=""
                    id=""
                    class="dropdown"
                    v-model="selectedZoneUpdated.ban_on_enter"
                >
                    <option value="false">False</option>
                    <option value="true">True</option>
                </select>
            </div>

            <div class="modal-input">
                <label for="zone-ban-on-enter-duration" class="label"
                    >Ban On Enter Duration (mins)</label
                >
                <input
                    type="number"
                    id="zone-ban-on-enter-duration"
                    class="input"
                    v-model="selectedZoneUpdated.ban_on_enter_duration"
                />

            </div>
          </div>

          <div class="modal-row" >
            <div class="modal-input">
                <label for="zone-ban-on-kill" class="label"
                    >Ban On kill</label
                >
                <select
                    name=""
                    id=""
                    class="dropdown"
                    v-model="selectedZoneUpdated.ban_on_kill"
                >
                    <option value="false">False</option>
                    <option value="true">True</option>
                </select>
            </div>

            <div class="modal-input">
                <label for="zone-ban-on-kill-duration" class="label"
                    >Ban On kill Duration (mins)</label
                >
                <input
                    type="number"
                    id="zone-ban-on-kill-duration"
                    class="input"
                    v-model="selectedZoneUpdated.ban_on_kill_duration"
                />

            </div>
          </div>

          <div class="modal-row" >
            <div class="modal-input">
                <label for="zone-ban-on-build" class="label"
                    >Ban On build</label
                >
                <select
                    name=""
                    id=""
                    class="dropdown"
                    v-model="selectedZoneUpdated.ban_on_build"
                >
                    <option value="false">False</option>
                    <option value="true">True</option>
                </select>
            </div>

            <div class="modal-input">
                <label for="zone-ban-on-build-duration" class="label"
                    >Ban On build Duration (mins)</label
                >
                <input
                    type="number"
                    id="zone-ban-on-build-duration"
                    class="input"
                    v-model="selectedZoneUpdated.ban_on_build_duration"
                />

            </div>
          </div>


          <div class="modal-row">
            <div class="modal-input">
                <label for="zone-kill-credit-multiplier" class="label"
                    >Kill Credits Multiplier</label
                >
                <input
                    type="number"
                    id="zone-kill-credit-multiplier"
                    class="input"
                    v-model="selectedZoneUpdated.kill_credit_multiplier"
                />
            </div>
          </div>

          <div class="modal-row full-row">
            <div class="modal-input">
                <label for="zone-ignore-list" class="label"
                    >Gamertags to ignore (Seperate with ,)</label
                >
                <textarea
                    type="textarea"
                    id="zone-ignore-list"
                    class="input"
                    v-model="ignoreListEdit"
                    placeholder="Gamertags to ignore (Seperate with ,)"
                >
                </textarea>
            </div>
          </div>

          <div class="modal-row full-row">
            <div class="modal-input">
                <label for="zone-description" class="label"
                    >Zone Description</label
                >
                <textarea
                    type="textarea"
                    id="zone-description"
                    class="input"
                    v-model="selectedZoneUpdated.zone_description"
                   
                >
                </textarea>
            </div>
          </div>

          
          
          </div>
        </div>

        

      </template>

      <template v-slot:footer-content v-if="modalContent === 'addZone'">
        <div class="modal-footer-content-container">
            <button class="modal-btn cancel-btn" @click="cancelZoneCreation">
            Cancel
          </button>
          <button
            class="modal-btn save-btn"
            v-if="!finalConfirm"
            :disabled="!newZone.zone_name || !newZone.zone_type || (!newZone.radius && newZone.zone_type === 'radius')"
            @click="proceedWithCreation"
          >
            <svg
              width="17"
              height="16"
              viewBox="0 0 17 16"
              fill="none"
              xmlns="http://www.w3.org/2000/svg"
            >
              <path
                d="M3.83325 8.66675L6.49992 11.3334L13.1666 4.66675"
                stroke="black"
                stroke-width="1.5"
                stroke-linecap="round"
                stroke-linejoin="round"
              />
            </svg>
            <p class="btn-text">Proceed</p>
          </button>
          <button
            class="modal-btn save-btn"
            v-if="finalConfirm"
            :disabled="!newZone.zone_name || !newZone.zone_type || (!newZone.radius && newZone.zone_type === 'radius')"
            @click="finishNewZone"
          >
            <svg
              width="17"
              height="16"
              viewBox="0 0 17 16"
              fill="none"
              xmlns="http://www.w3.org/2000/svg"
            >
              <path
                d="M3.83325 8.66675L6.49992 11.3334L13.1666 4.66675"
                stroke="black"
                stroke-width="1.5"
                stroke-linecap="round"
                stroke-linejoin="round"
              />
            </svg>
            <p class="btn-text">Create Zone</p>
          </button>
         
        </div>
      </template>

      <template v-slot:footer-content v-if="modalContent === 'zoneEditor'">
        <div class="modal-footer-content-container">
            <button class="modal-btn cancel-btn" @click="cancelZoneEdit">
            Cancel
          </button>
          <button
            class="modal-btn save-btn"
            @click="saveZoneEditChanges"
          >
            <svg
              width="17"
              height="16"
              viewBox="0 0 17 16"
              fill="none"
              xmlns="http://www.w3.org/2000/svg"
            >
              <path
                d="M3.83325 8.66675L6.49992 11.3334L13.1666 4.66675"
                stroke="black"
                stroke-width="1.5"
                stroke-linecap="round"
                stroke-linejoin="round"
              />
            </svg>
            <p class="btn-text">Save</p>
          </button>
         
        </div>
      </template>

      <template v-slot:footer-content v-if="modalContent === 'editZones'">
        <div class="modal-footer-content-container">
            <button class="modal-btn cancel-btn" @click="showModal = false">
            Close
          </button>
         
         
        </div>
      </template>
    </Modal>


  </template>

  
  
  <script>
  import { mapState } from 'vuex';
  import axios from 'axios';
  import { toRaw } from 'vue'; // ✅ Import toRaw from Vue
  import Modal from './Modal.vue';
  import { validatePagePermissions } from '../utils/permissions';
  import { h, readonly } from 'vue';
  export default {
    name: 'Zones',
    components: {
      Modal,
    },
    data() {
      return {

        selectedGameServer: null,
        mapData: null,
        map: null,
        allowAddZone: true,
        showModal: false,
        modalContent: '',
        newZone: null,
        rasterCoords: null,
        finalConfirm: false,
        mouseCoordinates: {
          x: 0,
          y: 0,
        },
        radiusCircle: null,
        polygonShape: null,
        loadedZones: null,
        hiddenZones: [],
        showFilterModal: false,
        searchFilter: '',
        selectedZoneUpdated: {},
        editingZone: false,
        editZoneMarker: null,
        zoneLayers: []
        
        
      };
    },
  
    computed: {

        ignoreListAdd: {
            get() {
                // if the newZone.ignore_list is a list, return it, else if a string, split it by comma and return the array
                if (this.newZone.ignore_list) {
                    if (Array.isArray(this.newZone.ignore_list)) {
                        return this.newZone.ignore_list;
                    } else if (typeof this.newZone.ignore_list === 'string') {
                        return this.newZone.ignore_list.split(',');
                    } else {
                        return [];
                    }
                } else {
                    return [];
                }
            },
            set(value) {
                // set the value to an array always
                if (Array.isArray(value)) {
                    this.newZone.ignore_list = value;
                } else if (typeof value === 'string') {
                    this.newZone.ignore_list = value.split(',');
                } else {
                    this.newZone.ignore_list = [];
                }
            }
        },

        ignoreListEdit: {
            get() {
                // if the selectedZoneUpdated.ignore_list is a list, return it, else if a string, split it by comma and return the array
                if (this.selectedZoneUpdated.ignore_list) {
                    if (Array.isArray(this.selectedZoneUpdated.ignore_list)) {
                        return this.selectedZoneUpdated.ignore_list;
                    } else if (typeof this.selectedZoneUpdated.ignore_list === 'string') {
                        return this.selectedZoneUpdated.ignore_list.split(',');
                    } else {
                        return [];
                    }
                } else {
                    return [];
                }
            },
            set(value) {
                // set the value to an array always
                if (Array.isArray(value)) {
                    this.selectedZoneUpdated.ignore_list = value;
                } else if (typeof value === 'string') {
                    this.selectedZoneUpdated.ignore_list = value.split(',');
                } else {
                    this.selectedZoneUpdated.ignore_list = [];
                }
            }
        },

        channels() {
            return this.$store.state.cachedRolesChannelsUsers.channels;
        },

        roles() {
            return this.$store.state.cachedRolesChannelsUsers.roles;
        },

        allLinkedServers() {
        return this.$store.state.linked_servers;
      },

      filteredZones() {
        if (!this.loadedZones || this.loadedZones.length === 0) {
          return [];
        }
        if (!this.searchFilter) {
          return this.loadedZones;
        }
        return this.loadedZones.filter((zone) =>
          zone.zone_name.toLowerCase().includes(this.searchFilter.toLowerCase())
        );
      },
     
    },
  
    methods: {

        cancelZoneEdit() {
            this.showModal = false;
            this.selectedZoneUpdated = null;
            this.editingZone = false;
            this.loadZones();
        },

        cancelZoneCreation() {
            this.showModal = false;
            this.newZone = null;
            this.finalConfirm = false;
            this.loadZones();
        },


        clearMap() {
            // remove all instances of markers, polygons and circles from the map
            this.map.eachLayer((layer) => {
                if (layer instanceof L.Marker || layer instanceof L.CircleMarker || layer instanceof L.Polygon) {
                    this.map.removeLayer(layer);
                }
            });
            this.hiddenZones = [];
            this.zoneLayers = []
        },

        hideZone(zone_id, layer) {
            if (!this.hiddenZones.some(zone => zone.zone_id === zone_id)) {
                this.hiddenZones.push({ zone_id: zone_id});
            } else {
                this.hiddenZones = this.hiddenZones.filter(zone => zone.zone_id !== zone_id);
            }
            this.map.removeLayer(layer);
        },

        drawZone(zone) {
            if (zone.zone_type === 'radius') {
                let existingLayer = this.zoneLayers.find(layer => layer.options.zone_id === zone.zone_id);
                if (existingLayer) {
                    this.map.addLayer(existingLayer);
                    return existingLayer; // Return the existing layer if found
                }
                let latlng = this.convertDayzCoordinatesToLatLng(zone.point[0], zone.point[1]);
                let layer = L.circleMarkerScaling(latlng, {
                color: 'red',
                radius: zone.radius / this.mapData.dividend,
                zone_id: zone.zone_id,
              })
            //   check if theres an object with the same zone_id in the zoneLayers array, if so, just return the layer
                
              this.map.addLayer(layer);
                this.zoneLayers.push(layer); // Add the layer to the zoneLayers array
              return layer
            } else if (zone.zone_type === 'shape') {
                

                let existingLayer = this.zoneLayers.find(layer => layer.options.zone_id === zone.zone_id);  
                if (existingLayer) {
                    
                    this.map.addLayer(existingLayer);
                    let layerPoints = existingLayer.getLatLngs()[0].map(latlng => {
                        return this.convertToDayzCoordinates(latlng.lat, latlng.lng);
                    });
                    
                    return existingLayer; // Return the existing layer if found
                }


                let polygonCoords = zone.polygon.map(nestedArray => {
                    return this.convertDayzCoordinatesToLatLng(nestedArray[0], nestedArray[1]);
                })
                
                let layer = L.polygon(polygonCoords, {
                    color: 'blue',
                    zone_id: zone.zone_id,
                    
                })
                    
                this.map.addLayer(layer);
                this.zoneLayers.push(layer); // Add the layer to the zoneLayers array
                return layer
            }
        },

        getZoneLayer(zone_id) {
            return this.zoneLayers.find(layer => layer.options.zone_id === zone_id);
        },

        updateShapeZone() {
            this.editingZone = true;
            this.showModal = false;
            this.zoneLayers.forEach(layer => {
                if (layer.options.zone_id !== this.selectedZoneUpdated.zone_id) {
                    this.map.removeLayer(layer);
                }
            });

            // grab the zone layer
            let zoneLayer = this.getZoneLayer(this.selectedZoneUpdated.zone_id);

          

            // create div-icons at each of the shapes points
            let points = zoneLayer.getLatLngs()[0]


            let markers = points.map((point) => {
                return L.marker(point, {
                    icon: L.divIcon({
                        className: 'leaflet-div-icon ',
                        iconSize: [16, 16],  // Keep the size
                        iconAnchor: [8, 8], // Center it (half of iconSize)
                    }),
                    draggable: true, // ✅ Make the marker draggable
                }).addTo(this.map);
            });
            zoneLayer.markers = markers; // Store the markers in the zoneLayer object
           
            // ✅ **Add drag event listener to update the polygon shape dynamically**
            markers.forEach((marker, index) => {
                marker.on('drag', () => {
                    let updatedLatLngIndex = index; // Get the correct index of the dragged marker
                    let new_dayz_coords = this.convertToDayzCoordinates(marker.getLatLng());

                    // ✅ Update the polygon array at the correct index
                    this.selectedZoneUpdated.polygon[updatedLatLngIndex] = [new_dayz_coords.x, new_dayz_coords.y];

                    let updatedLatLngs = markers.map(m => m.getLatLng());

                   

                    // ✅ Only update the Leaflet polygon if it's not automatically closed
                    let updatedZone = this.getZoneLayer(this.selectedZoneUpdated.zone_id);
                    updatedZone.setLatLngs(updatedLatLngs);

                });
            });



            // add click event for more points
            this.map.on('click', (e) => {
                let coords = this.convertToDayzCoordinates(e.latlng)
                this.selectedZoneUpdated.polygon.push([coords.x, coords.y])
                let newMarker = L.marker(e.latlng, {
                    icon: L.divIcon({
                        className: 'leaflet-div-icon invisible-icon',
                        iconSize: [16, 16],  // Keep the size
                        iconAnchor: [8, 8], // Center it (half of iconSize)
                    }),
                    draggable: true, // ✅ Make the marker draggable
                }).addTo(this.map);
                zoneLayer.markers.push(newMarker); // Store the new marker in the zoneLayer object
                // add the new marker to the polygon
                let updatedLatLngs = zoneLayer.markers.map(m => m.getLatLng()); // Get updated marker positions
                zoneLayer.setLatLngs(updatedLatLngs); // Update the polygon with new positions

                newMarker.on('drag', () => {
                    let updatedLatLngIndex = zoneLayer.markers.indexOf(newMarker); // Get the index of the dragged marker

                    let new_dayz_coords = this.convertToDayzCoordinates(newMarker.getLatLng());
                    this.selectedZoneUpdated.polygon[updatedLatLngIndex] = [new_dayz_coords.x, new_dayz_coords.y]; // Update the DayZ coordinates
                    let updatedLatLngs = zoneLayer.markers.map(m => m.getLatLng()); // Get updated marker positions
                    zoneLayer.setLatLngs(updatedLatLngs); // Update the polygon with new positions
                });
            });

            

        },

        getChangedKeyValuePairs(changdObject, originalObject) {
            let changedValues = {};
            for (let key in changdObject) {
                if (changdObject[key] !== originalObject[key]) {
                changedValues[key] = changdObject[key];
                }
            }
            return changedValues;
        },

        async saveZoneEditChanges() {
            this.showModal = false
            this.editingZone = false
            this.modalContent = ''
            this.mouseCoordinates = {
          x: 0,
          y: 0,
        }

            let changedValues = this.getChangedKeyValuePairs(this.selectedZoneUpdated, this.loadedZones.find(zone => zone.zone_id === this.selectedZoneUpdated.zone_id));
           
            if (Object.keys(changedValues).length > 0) {
                const response = await this.$store.dispatch('sendRequest', {
                    method: 'PUT',
                    url: `${this.$store.state.apiUrl}/api/zones`,
                    data: {
                        zone_id: this.selectedZoneUpdated.zone_id,
                        ...changedValues,
                    },
                    show_message_on_success: true,
                });

                if (!response) {
                    return
                }

                let cachedZones = this.$store.state.cachedZones.zones
                ? this.$store.state.cachedZones.zones
                : [];

                // update the cached zone if it exists, then push it to the array
                let existingZoneIndex = cachedZones.findIndex(
                    (zone) => zone.zone_id === this.selectedZoneUpdated.zone_id
                );
                if (existingZoneIndex !== -1) {
                    cachedZones[existingZoneIndex] = response.zone;
                } else {
                    cachedZones.push(response.zone);
                }


                const websocketMessage = {
                    event: "update_cached_zones",
                    discord_server_id: this.$store.state.client_discord_server_id,
                    data: {
                        zones: cachedZones,
                        lastCacheTimestamp: new Date(),
                    },
                };
                this.$store.state.websocket.send(
                    JSON.stringify(websocketMessage)
                );
            }

            // remove all click and mousemove events from the map
            this.map.off('click');
            this.map.off('mousemove');
            await this.loadZones()
            



        },

        confirmZoneEditChanges() {
            this.showModal = true
            this.editingZone = false

            // remove all click and mousemove events from the map
            this.map.off('click');
            this.map.off('mousemove');

            let layer = this.getZoneLayer(this.selectedZoneUpdated.zone_id);

            layer.markers.forEach((marker) => {
                this.map.removeLayer(marker); // Remove the marker from the map
            });

        


        },

        updateRadiusCoordinates() {

            
            

            this.editingZone = true;
            this.showModal = false;

           
            this.map.eachLayer((layer) => {
            // Check if the layer has a `zone_id` property and is not the selected zone
            if (layer.options && layer.options.zone_id && layer.options.zone_id !== this.selectedZoneUpdated.zone_id) {
                this.hideZone(layer.options.zone_id)
            }
            });

            // grab the zone layer
            let zoneLayer = this.getZoneLayer(this.selectedZoneUpdated.zone_id);

            // update the zone layer with the radius incase the user has changed it
            zoneLayer.setRadius(this.selectedZoneUpdated.radius / this.mapData.dividend);

            // add hover event to the map to get the coordinates
            this.map.on('mousemove', (e) => {
                let coords = this.convertToDayzCoordinates(e.latlng)
                this.mouseCoordinates.x = coords.x
                this.mouseCoordinates.y = coords.y
            });

            let latlng = this.convertDayzCoordinatesToLatLng(this.selectedZoneUpdated.point[0], this.selectedZoneUpdated.point[1]);
            
            let marker = L.marker(latlng, {
                icon: L.divIcon({
                    className: 'leaflet-div-icon invisible-icon',
                    iconSize: [16, 16],  // Keep the size
                    iconAnchor: [8, 8], // Center it (half of iconSize)
                }),
                draggable: true, // ✅ Make the marker draggable
            }).addTo(this.map);
            zoneLayer.markers = [marker]; // Store the marker in the zoneLayer object

            // add a drag event to the marker, so we can move the circle with it
            marker.on('drag', () => {
                let new_dayz_coords = this.convertToDayzCoordinates(marker.getLatLng());
                this.selectedZoneUpdated.x_coordinate = new_dayz_coords.x;
                this.selectedZoneUpdated.y_coordinate = new_dayz_coords.y;
                this.selectedZoneUpdated.point = [new_dayz_coords.x, new_dayz_coords.y];
                zoneLayer.setLatLng(marker.getLatLng());
            });

        },

        showModalPopup(modalContent, zone_id = null) {
            this.modalContent = modalContent;

            if (modalContent === 'addZone') {
                this.newZone = {}
                this.newZone.server_id = this.selectedGameServer.id
                this.clearMap()
            } else if (modalContent === 'editZones') {
                this.clearMap()
                
            } else if (modalContent === 'zoneEditor') {

                let zone = this.loadedZones.find(zone => zone.zone_id === zone_id);
                this.selectedZoneUpdated = JSON.parse(JSON.stringify(zone));
                this.selectedZoneUpdated.zone_type = zone.point ? 'radius' : 'shape';
                // clear all current markers/zones
                this.clearMap()

                // remove all click and mousemove events from the map
                this.map.off('click');
                this.map.off('mousemove');

                this.drawZone(zone);


                
            }

        


            this.showModal = true;
        },



        toggleZone(event) {
            if (!event.target.classList.contains('checkbox-label')) {
                return;
            }
            let zone_id = Number(event.target.id);
            
            if (!this.hiddenZones.some(hiddenZone => hiddenZone.zone_id === zone_id)) {
                // Find the zone in the map layers by the zone_id
                let zone = null;
                this.map.eachLayer((layer) => {
                    if (layer.options && layer.options.zone_id === zone_id) {
                    zone = layer; // Assign the matching layer to the `zone` variable
                    this.map.removeLayer(layer); // Remove the layer immediately
                    }
                });

                // Push the layer and zone_id into the hiddenZones array
                if (zone) {
                    this.hiddenZones.push({ zone_id: zone_id, layer: zone });
                    
                }
                } else {
                // If the zone is already hidden, restore it
                const hiddenZone = this.hiddenZones.find(hiddenZone => hiddenZone.zone_id === zone_id);
                if (hiddenZone) {
                    this.map.addLayer(hiddenZone.layer); // Add the layer back to the map
                    this.hiddenZones = this.hiddenZones.filter(hiddenZone => hiddenZone.zone_id !== zone_id); // Remove it from hiddenZones
                }
                }
        },

        openConfirmModal() {
            this.finalConfirm = true;
            this.showModal = true;
            this.map.off('click');
            this.map.off('mousemove');
            this.clearMap()

            if (this.newZone) {
                
                this.newZone.markers.forEach(marker => {
                    this.map.removeLayer(marker); // Remove the marker from the map
                });

                this.newZone.markers = [] // clear the markers array
            }

            

        },

       

        removeLastPolygonPoint(e) {
            e.stopPropagation();
            if (this.newZone.polygon && this.newZone.polygon.length > 0) {
                // remove the last point from the polygon
                this.newZone.polygon.pop();
                // convert the polygon to latlngs
                let latlngs = this.newZone.polygon.map(point => {
                    return this.convertDayzCoordinatesToLatLng(point[0], point[1]);
                });
                // set the latlngs to the polygon shape
                this.polygonShape.setLatLngs(latlngs);
                // remove the last marker from the markers array
                let lastMarker = this.newZone.markers.pop();
                // remove the marker from the map
                this.map.removeLayer(lastMarker);
            }
        },

        removeLastPolygonPointEdit(e) {
            e.stopPropagation();
            if (this.selectedZoneUpdated.polygon && this.selectedZoneUpdated.polygon.length > 0) {
                let layer = this.getZoneLayer(this.selectedZoneUpdated.zone_id);
                
                // remove the last point from the polygon
                this.selectedZoneUpdated.polygon.pop();
                // remove the last marker from the markers array
                let lastMarker = layer.markers.pop();
                // convert the polygon to latlngs
                let latlngs = this.selectedZoneUpdated.polygon.map(point => {
                    return this.convertDayzCoordinatesToLatLng(point[0], point[1]);
                });
                // set the latlngs to the polygon shape
                layer.setLatLngs(latlngs);
                // remove the marker from the map
                this.map.removeLayer(lastMarker);
                
            }
        },

        async updateSelectedGameServer() {
            let mapSize = this.selectedGameServer.map === 'chernarusplus' ? 15360 : 12800;
            let div = 32768 / mapSize;
            let map = {
                name: this.selectedGameServer.map,
                size: this.selectedGameServer.map === 'chernarusplus' ? 15360 : 12800,
                dividend: div,
                imageSize: [32768, 32768],
                centreLangLat: [(mapSize / 2) * div, (mapSize / 2) * div]
            }
            this.mapData = map;
            this.loadMap();
            await this.$store.dispatch('getRolesChannelsUsers');

           
        },

        loadMap() {

            const map = L.map('gameMap', {
            preferCanvas: true,
            attributionControl: false,
            crs: L.CRS.Simple,
            zoom: 1,
            minZoom: 1,
            maxZoom: 7,
            zoomControl: false,
            });

            this.rasterCoords = new L.RasterCoords(map, this.mapData.imageSize, 256, false);
            map.setView(this.rasterCoords.unproject(this.mapData.centreLangLat), 1);

            

            L.tileLayer('https://static.xam.nu/dayz/maps/chernarusplus/1.27/topographic/{z}/{x}/{y}.webp', {
            bounds: this.rasterCoords.getMaxBounds(),
            maxNativeZoom: this.rasterCoords.zoomLevel(),
            }).addTo(map);

            // Scaled circle markers
            L.CircleMarkerScaling = L.CircleMarker.extend({
            _project: function () {
                this._point = this._map.latLngToLayerPoint(this._latlng);
                this._radius = 4 * this.options.radius * this._map.getZoomScale(this._map.getZoom(), this._map
                .getMaxZoom());
                this._updateBounds();
            }
            });
            L.circleMarkerScaling = function (latlng, options) {
            return new L.CircleMarkerScaling(latlng, options);
            };


            this.map = map;

        },

       

        async getZones() {
            // check the store for cached zones
        let cachedZones = this.$store.state.cachedZones.zones
        ? this.$store.state.cachedZones.zones
        : null;

      

      if (cachedZones) {
        
        let cached_time = this.$store.state.cachedZones.lastCacheTimestamp;
        if (cached_time) {
          cached_time = new Date(cached_time);
        }
       
        let current_time = new Date();
        
        let time_difference = current_time - cached_time;
        
        // if less than 10 minutes, use the cached shop items
        if (time_difference < 600000) {
            let filtered_zones = cachedZones.filter(zone => zone.server_id === this.selectedGameServer.id);
            return filtered_zones;
          
        }

        let zones = await this.fechZones();
       
        if (zones) {
            const websocketMessage = {
            event: "update_cached_zones",
            discord_server_id: this.$store.state.client_discord_server_id,
            data: {
              zones: zones,
              lastCacheTimestamp: new Date(),
            },
          };

          this.$store.state.websocket.send(
            JSON.stringify(websocketMessage)
          );
            return zones.filter(zone => zone.server_id === this.selectedGameServer.id);
        }


        }

        },

        async fechZones() {
            const response = await this.$store.dispatch('sendRequest', {
            method: 'GET',
            url: `${this.$store.state.apiUrl}/api/zones`,
            params: {
            server_id: this.selectedGameServer.id
            },
            show_message_on_success: false,
        });

        if (response) {
            return response
        } else {
            return []
        }
    },


    async loadZones () {
    // clear the map of all markers and circles
    this.clearMap();

    let zones = await this.getZones();
    this.loadedZones = zones;

    let radius_zones = zones.filter(zone => zone.point !== null);
    let shape_zones = zones.filter(zone => zone.point === null);

    // ✅ Use toRaw() to ensure Leaflet gets unwrapped objects
    let rawMap = toRaw(this.map);

    // for all the radius zones, add them as circle markers to the map
    radius_zones.forEach(zone => {
        zone.zone_type = 'radius';
        let layer = this.drawZone(zone);

        let htmlContent = `<div class="zone-popup-content"><p class="zone-popup-id">ID: ${zone.zone_id}</p><p class="zone-popup-name">Name: ${zone.zone_name}</p></div>`;

        // ✅ Bind popups using the raw map object to avoid proxy-related issues
        toRaw(layer).bindPopup(htmlContent, {
            closeButton: false,
            autoClose: false,
            className: 'zone-popup',
        }).openPopup();
    });

    // for all the shape zones, add them as polygon shapes to the map
    shape_zones.forEach(zone => {
        // ✅ Remove duplicate points to prevent Leaflet issues
        zone.polygon = zone.polygon.filter((point, index, self) =>
            index === self.findIndex((p) => p[0] === point[0] && p[1] === point[1])
        );

        zone.zone_type = 'shape';

        let layer = this.drawZone(zone);
        let htmlContent = `<div class="zone-popup-content"><p class="zone-popup-id">ID: ${zone.zone_id}</p><p class="zone-popup-name">Name: ${zone.zone_name}</p></div>`;

        // ✅ Ensure the popup is created with an unwrapped Leaflet object
        toRaw(layer).bindPopup(htmlContent, {
            closeButton: false,
            autoClose: false,
            className: 'zone-popup',
        }).openPopup();
    });
},


   

  convertToDayzCoordinates(latlng) {
    const mapCoords = this.rasterCoords.project(latlng);
    const round = (value, decimals) => Number(Math.round(value + 'e' + decimals) + 'e-' + decimals);
    let x = round(mapCoords.x / this.mapData.dividend, 4)
    let y = round(this.mapData.size - mapCoords.y / this.mapData.dividend, 4)

    if (x < 0 || x > this.mapData.size) {
      x = 0;
      y = 0;
    } else if (y < 0 || y > this.mapData.size) {
      y = 0;
      x = 0;
    }

    let returnData = {
      x: x,
      y: y
    };
    return returnData;
  },

  convertDayzCoordinatesToLatLng(x, y) {
    const mapCoords = this.rasterCoords.unproject([x * this.mapData.dividend, (this.mapData.size - y) * this.mapData.dividend]);
 
    return mapCoords;
  },


  proceedWithCreation() {

    this.showModal = false;
    // Use an arrow function to preserve the `this` context
    this.map.on('click', (e) => {
        this.confirmZonePosition(e);
    });

    this.map.on('mousemove', (e) => {
        this.mouseCoordinates = this.convertToDayzCoordinates(e.latlng);
        
        // if the user is creating a radius, show the radius, using a circle marker that moves with the mouse
        if (this.newZone.zone_type === 'radius') {
            this.newZone.point = [this.mouseCoordinates.x, this.mouseCoordinates.y];
            let layer = this.drawZone(this.newZone);
            layer.setLatLng(e.latlng);
        }
        
    });
  },



  confirmZonePosition(event) {

    if (this.newZone.zone_type === 'radius') {

        let layer = this.getZoneLayer(this.newZone.zone_id);
    // Create the circle
    // turn off the mousemove event
        this.map.off('mousemove');
        let dayz_coords = this.convertToDayzCoordinates(event.latlng);
        this.newZone.x_coordinate = dayz_coords.x;
        this.newZone.y_coordinate = dayz_coords.y;
        layer.setLatLng(event.latlng);
        this.map.off('click');
         // add a draggable div icon to the circle marker the same as the polygon points, to the centre of the radius, so we can drag and move it.
         let marker = L.marker(event.latlng, {
            icon: L.divIcon({
                className: 'leaflet-div-icon invisible-icon',
                iconSize: [16, 16],  // Keep the size
                iconAnchor: [8, 8], // Center it (half of iconSize)
            }),
            draggable: true, // ✅ Make the marker draggable
        }).addTo(this.map);
        this.newZone.markers = [marker]; 

        // add a drag event to the marker, so we can move the circle with it
        marker.on('drag', () => {
            let new_dayz_coords = this.convertToDayzCoordinates(marker.getLatLng());
            this.newZone.x_coordinate = new_dayz_coords.x;
            this.newZone.y_coordinate = new_dayz_coords.y;
            layer.setLatLng(marker.getLatLng());
        });

        // add another mousemove event to the map, so we can see the coordinates of the mouse, but dont update the circle
        this.map.on('mousemove', (e) => {
            let coords = this.convertToDayzCoordinates(e.latlng)
            this.mouseCoordinates.x = coords.x
            this.mouseCoordinates.y = coords.y
        });

        } else {
    let point = event.latlng;
    let dayz_coords = this.convertToDayzCoordinates(point);

    if (!this.newZone.polygon) {
        this.newZone.polygon = [];
    }
    this.newZone.polygon.push([dayz_coords.x, dayz_coords.y]);

    // Create a draggable marker with a custom div icon
    let marker = L.marker(point, {
        icon: L.divIcon({
            className: 'leaflet-div-icon',
            iconSize: [8, 8], 
        }),
        draggable: true, // ✅ Make the marker draggable
    }).addTo(this.map);

    // Store markers in an array
    if (!this.newZone.markers) {
        this.newZone.markers = [];
    }
    this.newZone.markers.push(marker);

    // If the polygon has only one point, initialize it
    if (this.newZone.polygon.length === 1) {
        this.polygonShape = L.polygon([point], {
            color: '#0000FF',
            fillColor: '#0000FF',
        }).addTo(this.map);
    } else {
        // Add the new point to the polygon
        this.polygonShape.addLatLng(point);
    }

    // ✅ **Add drag event listener to update the polygon shape dynamically**
    marker.on('drag', () => {
        let updatedLatLngIndex = this.newZone.markers.indexOf(marker); // Get the index of the dragged marker
        let dayzCoords = this.newZone.polygon[updatedLatLngIndex]; // Get the corresponding DayZ coordinates

        let new_dayz_coords = this.convertToDayzCoordinates(marker.getLatLng());
        this.newZone.polygon[updatedLatLngIndex] = [new_dayz_coords.x, new_dayz_coords.y]; // Update the DayZ coordinates
        let updatedLatLngs = this.newZone.markers.map(m => m.getLatLng()); // Get updated marker positions
        this.polygonShape.setLatLngs(updatedLatLngs); // Update the polygon with new positions
    });
}



  },

  async finishNewZone() {
    // send the new zone to the server
    const response = await this.$store.dispatch('sendRequest', {
        method: 'POST',
        url: `${this.$store.state.apiUrl}/api/zones`,
        data: this.newZone,
        show_message_on_success: true,
    });


    if (response) {
        this.showModal = false;
        this.finalConfirm = false;
        this.newZone = null;
        this.mouseCoordinates = {
          x: 0,
          y: 0,
        }

        this.clearMap()
        
     

        let cachedZones = this.$store.state.cachedZones.zones
        ? this.$store.state.cachedZones.zones
        : [];

        let newCachedZones = [...cachedZones, response.zone]

        const websocketMessage = {
            event: "update_cached_zones",
            discord_server_id: this.$store.state.client_discord_server_id,
            data: {
                zones: newCachedZones,
                lastCacheTimestamp: new Date(),
            },
        };
        this.$store.state.websocket.send(
            JSON.stringify(websocketMessage)
        );

    }
  }

    },
  
    created() {
      
    },
  };
  </script>
  
  <style scoped>

 

  .edit-icon {
    cursor: pointer;
  }

 
.mapToolbar {
    position: absolute;
    top: 10px;
    left: 10px;
    z-index: 1000;
    padding: 10px;
    border-radius: 8px;
    display: flex;
    gap: 8px;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    z-index: 1000;
    
  }

  .mapToolbarButton {
    background-color: white;
    border: 1px solid rgba(195, 238, 252, 0.16);
    border-radius: 12px;
    padding: 8px;
    cursor: pointer;
    display: flex;
    align-items: center;
    justify-content: center;
    width: 40px;
    height: 40px;
    transition: background-color 0.3s ease;
  }

  .coordinates-container {
    position: absolute;
    top: 20px;
    left: 50%;
    transform: translateX(-50%);
    background: white;
    color: black;
    padding: 8px 12px;
    border-radius: 4px;
    z-index: 1000;
    font-size: 12px;
    font-weight: 500;
    font-family: 'Inter';
  }

#gameMap {
      max-width: 600px;
      height: 450px;
      background: rgba(187, 218, 255, 0.04);
    border: 1px solid rgba(187, 218, 255, 0.08);
    border-radius: 16px;
    z-index: 1;
    }

    .leaflet-control {
        background-color: rgba(195, 218, 252, 0.08);
    }
  
  .choose-gameserver-dropdown {
    /* Frame 171 */
  
    box-sizing: border-box;
  
    display: inline-block;
    padding: 12px 16px;
    gap: 16px;
  
    max-width: 200px;
    height: 45px;
  
    border: 1px solid rgba(195, 238, 252, 0.16);
    border-radius: 12px;
  
    width: 100%;
  
    font-family: 'Inter';
    font-style: normal;
    font-weight: 500;
    font-size: 1.4rem;
    line-height: 150%;
    /* identical to box height, or 21px */
  
    color: #ffffff;
    appearance: none; /* Remove default arrow */
    background-image: url('data:image/svg+xml,<svg xmlns="http://www.w3.org/2000/svg" width="16" height="17" viewBox="0 0 16 17" fill="none"><path d="M12.6666 6.5L7.99992 11.1667L3.33325 6.5" stroke="white" stroke-opacity="0.8" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/></svg>');
    background-repeat: no-repeat;
    background-position: right 16px center; /* Position it 16px from the right edge */
    padding-right: 36px; /* Add padding to prevent the text from overlapping the arrow */
    cursor: pointer;
    background-color: rgba(195, 218, 252, 0.08);
  }
  
  .choose-gameserver-dropdown:focus {
    outline: none;
  }
  
  .choose-gameserver-dropdown option {
    color: black;
  }
  
  .gsoc-heading {
    text-align: left;
    margin: 0;
  }
  
  .gsoc-content {
    display: grid;
      grid-template-columns: repeat(auto-fit, minmax(200px, 200px));
      align-items: center;
      color: white;
      column-gap: 20px;
      row-gap: 10px;
  }
  
  .server-options-sub-heading {
    font-family: 'Inter';
    font-style: normal;
    font-weight: 500;
    font-size: 1.6rem;
    line-height: 150%;
    /* identical to box height, or 24px */
    text-align: left;
    color: #ffffff;
  }
  
  .gsoc-button {
    display: flex;
    padding: 12px 16px;
  
    max-width: 200px;
  
    border: 1px solid rgba(195, 238, 252, 0.16);
    background-color: rgba(195, 218, 252, 0.08);
    border-radius: 12px;
  
    font-family: 'Inter';
    font-style: normal;
    font-weight: 500;
    font-size: 1.6rem;
    line-height: 150%;
    /* identical to box height, or 24px */
    text-align: left;
    color: #ffffff;
    cursor: pointer;
  }
  
  .modal-sub-heading {
    /* COMMAND NAME */
  
    font-family: 'Inter';
    font-style: normal;
    font-weight: 500;
    font-size: 1.2rem;
    line-height: 15px;
    /* identical to box height */
    letter-spacing: 0.08em;
  
    color: #bbced8;
  }
  .modal-main-heading {
    /* Add Channels */
  
    font-family: 'Inter';
    font-style: normal;
    font-weight: 700;
    font-size: 2.4rem;
    line-height: 29px;
    /* identical to box height */
  
    color: #ffffff;
  
    margin-top: 8px;
  }
  
  /* Frame 171 */
  
  .config-option-dropdown {
    box-sizing: border-box;
  
    display: inline-block;
  
    padding: 8px 12px;
  
    border: 1px solid rgba(195, 238, 252, 0.16);
    border-radius: 12px;
  
    font-family: 'Inter';
    font-style: normal;
    font-weight: 500;
    font-size: 1.4rem;
    line-height: 150%;
    /* identical to box height, or 21px */
  
    color: #ffffff;
    appearance: none; /* Remove default arrow */
    background-image: url('data:image/svg+xml,<svg xmlns="http://www.w3.org/2000/svg" width="16" height="17" viewBox="0 0 16 17" fill="none"><path d="M12.6666 6.5L7.99992 11.1667L3.33325 6.5" stroke="white" stroke-opacity="0.8" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/></svg>');
    background-repeat: no-repeat;
    background-position: right 16px center; /* Position it 16px from the right edge */
    padding-right: 36px; /* Add padding to prevent the text from overlapping the arrow */
    cursor: pointer;
    background-color: rgba(195, 218, 252, 0.08);
  }
  
  .config-option-input,
  .config-option-dropdown {
    width: 165px;
  }
  .config-option-input {
    background-color: rgba(195, 218, 252, 0.08);
    box-sizing: border-box;
  
    display: inline-block;
  
    padding: 8px 12px;
  
    border: 1px solid rgba(195, 238, 252, 0.16);
    border-radius: 12px;
  
    font-family: 'Inter';
    font-style: normal;
    font-weight: 500;
    font-size: 1.4rem;
    line-height: 150%;
    /* identical to box height, or 21px */
  
    color: #ffffff;
  }
  .config-option-dropdown:focus,
  .config-option-input:focus {
    outline: none;
  }
  
  .config-option-dropdown option,
  .config-option-input option {
    color: black;
  }
  
  .modal-body-cc-inner {
    display: flex;
    flex-direction: column;
    row-gap: 12px;
  }
  .config-row {
    display: flex;
    justify-content: space-between;
  }
  
  .config-option {
    flex-direction: column;
    text-align: left;
    display: flex;
    row-gap: 4px;
  }
  
  .config-option label {
    font-family: 'Inter';
    font-style: normal;
    font-weight: 500;
    font-size: 1rem;
    line-height: 15px;
    /* identical to box height */
    /* letter-spacing: 0.08em; */
    padding-left: 5px;
  
    color: #bbced8;
  }

textarea {
    height: 120px;
}
  
  /* for screens below 700px */
  @media (max-width: 800px) {

    .flex-container {
        flex-direction: column;
    }
    
  }

 
  
  </style>
  